import angular, { IQService } from 'angular';
import { StateService } from 'angular-ui-router';
import moment from 'moment';
import { UtilityService } from '../../../core/services/utility.service';

import templateUrl from './list-time-cards-container.component.html'

export const ListTimeCardsContainerComponent = {
    controller: ListTimeCardsContainerController,
    controllerAs: "vm",
    templateUrl,
    bindings: {
        startDate: "<",
        endDate: "<",
        icdCorporationID: "<"
    }
};


function ListTimeCardsContainerController($q: IQService, $uibModal, $state: StateService,
    payrollDashboardService, timeCardService, utilityService: UtilityService, apexApiUrl: string) {
    'ngInject'

    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const vm = this;

    vm.$onInit = onInit;
    vm.filters;
    vm.onChangeFilters = onChangeFilters;
    vm.onApproveTimeCard = onApproveTimeCard;
    vm.approvedFilter;

    vm.unapprovedOnly = false;
    vm.timeOnly = true;
    vm.noTimeOnly = false;

    vm.timeCards = new kendo.data.ObservableArray([]);
    vm.handleCurrDateChange = handleCurrDateChange;
    vm.onChangeCompany = onChangeCompany;
    vm.onChangeDivision = onChangeDivision;

    vm.ReviewerTimeAdd = reviewerTimeAdd;
    vm.reviewTimeEntries = reviewTimeEntries;
    vm.filterShowUsers = filterShowUsers;
    vm.exportAll = exportAll;
    vm.loaded = false;

    function onInit() {
        vm.timeCardShowUsersWith = '0';
        utilityService.showLoading();
        loadDivisions().then(function () {
            loadApprovedDates()
                .then(loadTimeCards)
                .then(updatePageState)
                .catch(function (ex) {
                    console.error(ex);
                    alert("initial load failed:" + utilityService.getExceptionMessage(ex));
                })
                .then(utilityService.hideLoading)
                .then(() => vm.loaded = true)
        });
    }

    function onApproveTimeCard(timeCard) {
        const saved = timeCardService.approvePayPeriod(timeCard.PayPeriodID, timeCard.Approved);

        saved.catch(function () {
            // Roll back change to view.
            timeCard.Approved = !timeCard.Approved;
        })

        utilityService.showLoadingUntilResolved(
            utilityService.alertOnError(saved, "Approval failed"));
    }

    function loadTimeCards() {
        if (!vm.selectedRotation) {
            //reset results
            vm.timeCards.splice(0, vm.timeCards.length);
            return $q.resolve([]);
        }

        const query: any = {
            startDate: kendo.format("{0:yyyy-MM-dd}", vm.selectedRotation.StartDate),
            endDate: kendo.format("{0:yyyy-MM-dd}", vm.selectedRotation.EndDate),
            icdCorporationID: vm.selectedIcdCorporation ? vm.selectedIcdCorporation.Id : vm.icdCorporationID,
            unapprovedOnly: vm.unapprovedOnly,
            timeOnly: vm.timeOnly ? true : vm.noTimeOnly ? false : null
        }

        if (vm.filters) {
            query.EmployeeName = vm.filters.EmployeeGroup;
            query.Approved = vm.filters.Approved;
            query.TotalEntries = vm.filters.TotalEntries;
            query.ApprovedEntries = vm.filters.ApprovedEntries;
            query.NumHours = vm.filters.NumHours;
            query.ApproverFullName = vm.filters.ApproverFullName;
        }

        return timeCardService.retrievePayPeriods(query)
            .then(function (pagedEntityList) {
                return pagedEntityList.Entities;
            })
            .then(function (timeCards) {
                return timeCards.sort(function (a, b) {
                    return a.EmployeeFullName.toLowerCase() < b.EmployeeFullName.toLowerCase() ? -1 : 1;
                })
            })
            .then(function (data) {
                // this callback will be called asynchronously
                // when the response is available
                data.forEach(function (payPeriod) {
                    // Convert total hours into a breakdown of minutes and seconds.
                    const totalSeconds = Math.round(payPeriod.NumHours * 3600); // Round to the nearest whole second.
                    const numSeconds = Math.floor(totalSeconds % 60);
                    const numMinutes = Math.floor((totalSeconds - numSeconds) / 60 % 60); // Should be strictly positive since Math.floor is used.
                    const numHours = Math.floor((totalSeconds - numSeconds - numMinutes * 60) / 3600);
                    payPeriod.NumHours = payPeriod.NumHours !== 0
                        ? (numHours ? numHours + "h " : "") + (numMinutes !== 0 ? numMinutes + "m" : "")
                        : "0";
                });

                // Create a composite grouping
                angular.forEach(data, function (value, key) {
                    value.EmployeeGroup = value.EmployeeID + '|' + value.EmployeeFullName;
                });

                data = groupBy(data, "EmployeeGroup");
                vm.timeCards.splice(0, vm.timeCards.length);
                vm.timeCards.push(...data);
            })
    }

    function groupBy(collection, property) {
        let i = 0, val, index, keyValueObject: any = {};
        const values = [], result = [];

        for (; i < collection.length; i++) {
            val = collection[i][property];

            index = values.indexOf(val);
            if (index > -1) {
                result[index].values.push(collection[i]);
            } else {
                values.push(val);
                keyValueObject = { key: val, values: [] };
                keyValueObject.values.push(collection[i]);
                result.push(keyValueObject);
            }
        }
        return result;
    }
    //function to load divisions
    function loadDivisions() {
        return payrollDashboardService.retrievePayrollOfficeDivision()
            .then(function (data) {
                if (!data.Division) {
                    addDivisions(data.Divisions);
                    return loadCorporations()
                } else {
                    vm.rotationDivisions = [{ Id: data.Division.DivisionID, Name: data.Division.DisplayName }];
                    vm.selectedDivision = vm.rotationDivisions[0];
                    vm.icdCorporations = [{
                        Id: data.ICDOffice.IcdCorporationId,
                        Text: data.ICDOffice.IcdCorporationName
                    }];
                    vm.selectedIcdCorporation = vm.icdCorporations[0];
                }
            });
    }

    function loadCorporations() {
        if (vm.selectedDivision == null) {
            //handling cases where divisions api returns empty results
            vm.icdCorporations = [];
            return $q.resolve([]);
        }
        return (vm.selectedDivision.Id === 0 ?
            payrollDashboardService.retrievePayrollCorporationsV2({ CheckRCNCPO: true }) :
            payrollDashboardService.retrievePayrollCorporationsV2({
                DivisionID: vm.selectedDivision.Id,
                CheckRCNCPO: true
            })
        ).then(function (data) {
            addCorporations(data);
        })
    }

    function addDivisions(divisions) {
        if (divisions == null || divisions.length === 0) {
            vm.icdCorporations = [];
            vm.rotations = [];
            return;
        } else {
            vm.rotationDivisions = Object.values(divisions.reduce(function (divisions, dc) {
                if (!divisions[dc.DivisionID]) {
                    divisions[dc.DivisionID] = {
                        Id: dc.DivisionID,
                        Name: dc.DisplayName
                    };
                }
                return divisions;
            }, {}));
            vm.selectedDivision = vm.rotationDivisions[0];
            if (vm.rotationDivisions.length > 1) { //adding All Divisions only when multiple divisions are present
                vm.rotationDivisions.splice(0, 0, { Id: 0, Name: 'All Divisions' });
            }
        }
    }

    function addCorporations(offices) {
        if (offices.length === 0) {
            vm.icdCorporations = [];
            vm.selectedIcdCorporation = null;
            vm.rotations = [];
            vm.timeCards = [];
            return;
        } else {
            vm.icdCorporations = Object.values(offices.reduce(function (icdCorporations, icd) {
                const icdCorporation = {
                    Id: icd.Id,
                    ClientName: icd.ClientName,
                    Owner: icd.Owner,
                    Text: icd.ClientName
                };
                icdCorporations.push(icdCorporation);
                return icdCorporations;
            }, []));
            vm.selectedIcdCorporation = vm.icdCorporations[0];
        }
    }

    function loadApprovedDates() {
        if (vm.selectedIcdCorporation == null) {
            vm.rotations = [];
            // Select the default rotation for the page.
            vm.selectedRotation = null;
            vm.timeCards = [];
            return $q.resolve([]);
        } else {
            return payrollDashboardService.retrievePayrollRotationsV2(
                vm.selectedDivision.Id, vm.selectedIcdCorporation.Id)
                .then(function (rotations) {
                    return rotations.filter(function (rotation) {
                        return rotation.Payrolls.some(function (payroll) {
                            return payroll.CanRead; //return only payrolls with CanRead prop = true
                        });

                    });
                })
                .then(function (rotations) {
                    rotations.forEach(function (rotation, i) {
                        // Depending on if the rotation contains any unlocked payrolls, the default rotation
                        // selection will change.
                        rotation.AllLocked = rotation.Payrolls.reduce(function (all, payroll) {
                            return all && payroll.Locked;
                        }, rotation.Payrolls.length > 0);
                        rotation.Locked = rotation.AllLocked; // Used in the payroll select component.
                        rotation.PayrollID = i; // Used in the payroll select component to identify the selected payroll.
                    });
                    vm.rotations = rotations;
                    // Select the default rotation for the page.
                    vm.selectedRotation = selectDefaultRotation(rotations);

                    // Set a new default date based on the earliest unsubmitted rotation if the default one is invalid.
                    if (vm.selectedRotation) {
                        vm.startDate = vm.selectedRotation.StartDate;
                        vm.endDate = vm.selectedRotation.EndDate;
                    }
                });
        }
    }

    function selectDefaultRotation(rotations: any[]) {
        //get ordered list
        const orderedRotations = Array.from(rotations).sort(function (p, q) {
            return p.StartDate > q.StartDate ? -1 : 1;
        });

        //Get the last locked rotation
        const lastSubmittedRotation = orderedRotations.filter(p => p.Locked).sort(function (p, q) {
            return p.StartDate > q.StartDate ? -1 : 1;
        })[0];

        //Get the first unlocked rotation that is after the last locked (if any)
        const firstUnsubmittedRotation = orderedRotations.filter(function (payweek) {
            return !payweek.Locked && (!lastSubmittedRotation
                || payweek.StartDate >= lastSubmittedRotation.StartDate)
        }).sort(function (p, q) {
            return p.StartDate < q.StartDate ? -1 : 1;
        })[0];
        // Select the rotation with the given ID, or the first pay week in the list if none given.
        return firstUnsubmittedRotation
            // Select the first pay week in the list.
            || orderedRotations[0];
        /*}*/
    }
    function handleCurrDateChange() {
        if (vm.selectedRotation) {
            vm.endDate = moment(vm.selectedRotation.EndDate).toDate();
            vm.startDate = moment(vm.selectedRotation.StartDate).toDate();
        }

        updatePageState();

        utilityService.showLoading();
        return loadTimeCards()
            .then(utilityService.hideLoading);
    }

    function onChangeCompany() {
        updatePageState();
        if (vm.selectedIcdCorporation && vm.selectedDivision) {
            // Only need to reload data if the corporation changed.
            utilityService.showLoadingUntilResolved(
                utilityService.alertOnError(loadApprovedDates()
                    .then(fn => loadTimeCards()), "Changing Company failed"));
        }
    }

    function onChangeDivision() {
        if (vm.selectedDivision) {
            // Only need to reload data if the corporation changed.
            utilityService.showLoadingUntilResolved(
                utilityService.alertOnError(
                    loadCorporations()
                        .then(res => loadApprovedDates())
                        .then(res => loadTimeCards), "Changing division failed"));
        }
    }

    function updatePageState() {
        const updatedParams: any = {};
        if (vm.selectedRotation) {
            updatedParams.startDate = kendo.format("{0:yyyy-MM-dd}", vm.selectedRotation.StartDate);
            updatedParams.endDate = kendo.format("{0:yyyy-MM-dd}", vm.selectedRotation.EndDate);
            updatedParams.currDate = null;
        }
        if (vm.selectedIcdCorporation) {
            updatedParams.icdCorporationID = vm.selectedIcdCorporation.Id;
        }
        $state.go(".", updatedParams, { location: "replace" });
    }

    function reviewerTimeAdd(employeeKey) {
        vm.showAddTimeEntryPopup(employeeKey.split("|")[0], employeeKey.split("|")[1]);
    }

    // Generic Function
    vm.showAddTimeEntryPopup = function (empId, empName) {
        showTimeEntry({
            employeeId: empId,
            employeeName: empName,
            isNew: true
        });
    };

    /** Add Time Entry Code **/
    function showTimeEntry(args) {

        if (args.isNew) {
            if (!args.employeeId) {
                args.requireBreak = vm.requireBreak;
            }
        }

        args.startDate = vm.startDate;
        args.endDate = vm.endDate;
        $uibModal.open({
            component: "apexEditTimeEntryModal",
            windowClass: 'xx-dialog pagespinner',
            size: 'lg',
            backdrop: 'static',
            resolve: {
                entryData: function () {
                    return args;
                },
                isEmployerView: function () {
                    return true;
                }
            }
        }).result.then(function (item) {
            utilityService.showLoading();
            return loadTimeCards();
        })
            .catch(() => { })
            .then(utilityService.hideLoading);
    }

    function reviewTimeEntries(employeeId, unapprovedOnly) {
        const params: any = {
            startDate: vm.selectedRotation.StartDate,
            endDate: vm.selectedRotation.EndDate,
            currDate: null,
            icdCorporationID: vm.selectedIcdCorporation ? vm.selectedIcdCorporation.Id : undefined
        };
        if (employeeId) {
            params.employeeID = employeeId;
        }
        if (unapprovedOnly) {
            params.unapprovedOnly = true;
        }

        $state.go("timeEntry.reviewTime", params);
    }

    function filterShowUsers(option) {
        // eslint-disable-next-line eqeqeq
        if (option != undefined) {

            vm.noTimeOnly = false;
            vm.timeOnly = false;
            vm.unapprovedOnly = false;

            switch (option) {
                case 0:
                    vm.timeOnly = true;
                    break;
                case 1:
                    vm.unapprovedOnly = true;
                    break;
                case 2:
                    vm.noTimeOnly = true;
                    break;
            }
        }

        utilityService.showLoading();
        return loadTimeCards()
            .catch(angular.noop)
            .then(utilityService.hideLoading);
    }

    function onChangeFilters() {
        changeFilters();
    }

    const changeFilters = utilityService.debounce(function () {
        saveFilters();

        utilityService.showLoadingUntilResolved(
            utilityService.alertOnError(loadTimeCards(), "Filtering failed"));
    }, 500);

    function saveFilters() {
        localStorage.setItem("listTimeCardFilters", JSON.stringify(vm.filters || {}));
    }

    function exportAll() {
        if (vm.selectedIcdCorporation ? vm.selectedIcdCorporation.Id : vm.icdCorporationID != null) {
            const summaryDownload = kendo.format(apexApiUrl + "icd-corporations/{0}/timesheet.xlsx?startDate={1:yyyy-MM-dd}&endDate={2:yyyy-MM-dd}",
                vm.selectedIcdCorporation ? vm.selectedIcdCorporation.Id
                    : vm.icdCorporationID, vm.startDate, vm.endDate);
            window.location.href = summaryDownload;
        } else {
            alert("Action could not be performed successfully. A company must be selected");
        }

    }
}
